import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[var(--bg-dark)] text-white pt-24 md:pt-32 pb-10 relative overflow-hidden grain">
      <div className="container-page relative">
        {/* Massive CTA */}
        <div className="border-b border-white/15 pb-20 md:pb-28">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">{t.footer.ctaSub}</div>
          <a
            href="#contact"
            data-testid="footer-cta"
            className="group block mt-6"
          >
            <h2 className="font-display text-[clamp(3.5rem,11vw,12rem)] leading-[0.9] tracking-[-0.04em] text-white">
              {t.footer.cta}
              <span aria-hidden className="inline-block ml-4 transition-transform duration-500 group-hover:translate-x-6 group-hover:text-[var(--accent)]">→</span>
            </h2>
          </a>
        </div>

        {/* Columns */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/8py7eydi_logo-removebg-preview-300x300.png"
                alt="Castel Construct"
                className="h-12 w-12 object-contain invert brightness-0"
                style={{ filter: "invert(1) brightness(2)" }}
              />
              <span className="font-display text-xl">
                Castel<span className="italic"> Construct</span>
              </span>
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed">
              Cu o experiență de peste 5 ani și un accent real pe satisfacția clienților, suntem partenerul potrivit pentru proiectul tău.
            </p>
            <div className="mt-8 flex gap-4">
              <a href="https://www.facebook.com/castel.construct" target="_blank" rel="noreferrer" className="px-4 py-2 border border-white/20 hover:border-white text-sm transition-colors" data-testid="social-facebook">Facebook</a>
              <a href="https://www.instagram.com/castelconstruct.srl" target="_blank" rel="noreferrer" className="px-4 py-2 border border-white/20 hover:border-white text-sm transition-colors" data-testid="social-instagram">Instagram</a>
              <a href="https://www.tiktok.com/@castel.construct2" target="_blank" rel="noreferrer" className="px-4 py-2 border border-white/20 hover:border-white text-sm transition-colors" data-testid="social-tiktok">TikTok</a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50 mb-5">Navigare</div>
            <ul className="space-y-3">
              <li><a href="/" className="text-lg hover:text-[var(--accent)] transition-colors">{t.footer.links.home}</a></li>
              <li><a href="/#about" className="text-lg hover:text-[var(--accent)] transition-colors">{t.footer.links.about}</a></li>
              <li><a href="/#services" className="text-lg hover:text-[var(--accent)] transition-colors">{t.footer.links.services}</a></li>
              <li><a href="/#contact" className="text-lg hover:text-[var(--accent)] transition-colors">{t.footer.links.contact}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50 mb-5">Contact</div>
            <ul className="space-y-3 text-lg">
              <li><a href="tel:+37368257835" className="hover:text-[var(--accent)] transition-colors">+373 68 257 835</a></li>
              <li><a href="mailto:castelconstructsrl@gmail.com" className="hover:text-[var(--accent)] transition-colors break-all">castelconstructsrl@gmail.com</a></li>
              <li className="text-white/70">MD-2084, Strada Chișinăului 62, Cricova, mun. Chișinău</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
          <div>© {year} Castel Construct SRL · {t.footer.rights}</div>
          <div>Designed in Chișinău · Built with care</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
